import { animate, useInView, useMotionValue } from 'framer-motion'
import { useEffect, useMemo, useRef, useState } from 'react'

function formatNumber(value: number, decimals: number) {
  return value.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
}

export function AnimatedNumber({
  value,
  decimals = 0,
  duration = 1.1,
}: {
  value: number
  decimals?: number
  duration?: number
}) {
  const ref = useRef<HTMLSpanElement | null>(null)
  const inView = useInView(ref, { once: true, amount: 0.7 })
  const mv = useMotionValue(0)
  const [current, setCurrent] = useState(0)

  const rounded = useMemo(() => {
    const factor = Math.pow(10, decimals)
    return Math.round(current * factor) / factor
  }, [current, decimals])

  useEffect(() => {
    const unsub = mv.on('change', (v) => setCurrent(v))
    return () => unsub()
  }, [mv])

  useEffect(() => {
    if (!inView) return
    const controls = animate(mv, value, { duration, ease: [0.21, 0.75, 0.2, 1] })
    return () => controls.stop()
  }, [duration, inView, mv, value])

  return (
    <span ref={ref} className="tabular-nums">
      {formatNumber(rounded, decimals)}
    </span>
  )
}


